<template>
  <div class="header-box" :class="isShowHead?'on':''">
    <div class="header-main">
      <div class="logo">
        <a href="/">
          <img v-if="isShowHead" src="~@/assets/img/RUANWO-logo2.webp">
          <img v-else src="~@/assets/img/RUANWO-logo.webp">
        </a>
      </div>
      <div class="nav">
        <ul>
          <li
              v-for="(item,index) in headerNav"
              :key="index"
              :class="navCurrIndex == index ? 'on':''"
          >
            <div class="nav-item-title" @click="getNav(item, index)">
              {{ $t(item.name) }}
            </div>

            <div v-if="item.list && item.list.length" class="sub-nav">
              <div
                  v-for="(sub, subIdx) in item.list"
                  :key="subIdx"
                  class="sub-item"
                  @click="goSub(sub, index)"
              >
                {{ $t(sub.name) }}
                <span v-if="sub.children" class="arrow">></span>
                <div v-if="sub.children" class="sub-sub-nav">
                  <div
                      v-for="(s, i) in sub.children"
                      :key="i"
                      class="sub-sub-item"
                      @click.stop="goSub(s, index)"
                  >
                    {{ $t(s.name) }}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 语言切换器 -->
      <div class="lang-switch" @click.stop="toggleLangMenu">
        <span class="lang-icon">🌐</span>
        <span class="lang-text">{{ currentLangText }}</span>
        <span class="lang-arrow" :class="{ open: langMenuOpen }">▼</span>
        <ul v-if="langMenuOpen" class="lang-menu" @click.stop>
          <li
              v-for="lang in langList"
              :key="lang.value"
              :class="{ active: locale === lang.value }"
              @click="changeLang(lang.value)"
          >
            {{ lang.label }}
          </li>
        </ul>
      </div>
      <!--<div class="Contact-Us">{{ $t('common.contactUs') }}</div>-->
    </div>
  </div>
</template>

<script>
import menu from "@/config/menu.json";
export default {
  name: "Header",
  data(){
    return {
      isShowHead:false,
      navCurrIndex:0,
      headerNav: menu,
      locale: localStorage.getItem('locale') || 'zh',
      langMenuOpen: false,
      langList: [
        { value: 'zh', label: '中文' },
        { value: 'en', label: 'English' }
      ]
    }
  },
  computed: {
    currentLangText() {
      return this.locale === 'zh' ? '中文' : 'EN'
    }
  },
  mounted() {
    this.navCurrIndex = this.$route.meta.index
    this.setHeaderStatus()
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('click', this.closeLangMenu)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('click', this.closeLangMenu)
  },
  watch: {
    '$route.path'() {
      this.setHeaderStatus()
    }
  },
  methods: {
    toggleLangMenu() {
      this.langMenuOpen = !this.langMenuOpen
    },
    closeLangMenu() {
      this.langMenuOpen = false
    },
    changeLang(lang) {
      this.locale = lang
      this.$i18n.locale = lang
      localStorage.setItem('locale', lang)
      this.langMenuOpen = false
    },
    setHeaderStatus() {
      const path = this.$route.path;
      console.log(path);

      // 查找父级 index：优先匹配父级 path，否则检查 list 子菜单
      const Index = this.headerNav.findIndex(it => {
        // 1. 父级直接匹配
        if (it.path.includes(path)) return true;
        // 2. 检查 list 子菜单中是否存在匹配的 path
        if (it.list && Array.isArray(it.list)) {
          return it.list.some(child => child.path && child.path.includes(path));
        }
        return false;
      });

      this.navCurrIndex = Index;

      // 查找匹配的项（同样支持 list 子菜单匹配）
      const item = this.headerNav.find(it => {
        if (it.path.includes(path)) return true;
        if (it.list && Array.isArray(it.list)) {
          return it.list.some(child => child.path && child.path.includes(path));
        }
        return false;
      });

      if (item?.alwaysOn) {
        this.isShowHead = true;
      } else {
        this.isShowHead = false;
      }
    },
    handleScroll() {
      const path = this.$route.path
      const item = this.headerNav.find(it => it.path.includes(path))
      if (item?.alwaysOn) {
        this.isShowHead = true
        return
      }
      const top = document.documentElement.scrollTop;
      this.isShowHead = top >= 86;
    },
    getNav(item,index){
      this.navCurrIndex = index
      this.isShowHead = !!item.alwaysOn
      if (!item.path) return;
      this.$router.push({
        path: item.path,
        query: {
          type: item.type
        }
      });
    },
    goSub(subItem, parentIndex) {
      if(!subItem.path) return
      this.navCurrIndex = parentIndex
      this.isShowHead = false
      this.$router.push(subItem.path)
    }
  }
}
</script>

<style scoped lang="less">
.header-box{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
  margin: auto;
  width: 100%;
  height: 86px;
  min-width: 1280px;
  transition: all 0.5s ease;
  background:transparent;
  &.on{
    height: 86px;
    background: #ffffff!important;
    box-shadow: 2px 2px 2px rgb(233 246 254);
    .nav ul li {
      color: #000 !important;
    }
  }
}
.Contact-Us{
  width: 116px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: #024BFF;
  border-radius:40px;
  color: #FFFFFF;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right:50px;
}
.header-main{
  max-width: 1440px;
  width: 90%;
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  .lang-switch{
    position: relative;
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 20px;
    padding: 6px 14px;
    border: 1px solid rgba(255,255,255,0.5);
    border-radius: 20px;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    user-select: none;
    background: rgba(255,255,255,0.1);
    backdrop-filter: blur(4px);
    &:hover{
      background: rgba(255,255,255,0.25);
    }
    .lang-icon{ margin-right: 6px; font-size: 16px; }
    .lang-text{ font-weight: 500; }
    .lang-arrow{
      margin-left: 8px;
      font-size: 10px;
      transition: transform 0.3s;
      &.open{ transform: rotate(180deg); }
    }
    .lang-menu{
      position: absolute;
      top: calc(100% + 8px);
      right: 0;
      min-width: 140px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.12);
      padding: 6px 0;
      list-style: none;
      margin: 0;
      color: #333;
      li{
        padding: 8px 16px;
        cursor: pointer;
        font-size: 14px;
        &:hover{ background: #f5f7fa; color: #024BFF; }
        &.active{ color: #024BFF; font-weight: 600; }
      }
    }
  }
  .on & .lang-switch{
    border-color: #024BFF;
    color: #000;
    background: #fff;
    &:hover{ background: #f0f6ff; }
  }
  .logo {
    float: left;
    height: 64px;
    display: flex;
    align-items: center;
    a{
      height: 64px;
      display: flex;
      align-items: center;
    }
    img{
      height: 51px;
    }
  }
  .nav{
    float: left;
    height: 100%;
    margin:0 0 0 100px;
    >ul{
      list-style: none;
      color:#fff;
      padding: 0;
      margin: 0;
      height: 100%;
      display: flex;
      align-items: center;
      li{
        position: relative;
        line-height: 86px;
        height: 100%;
        margin: 0 1.5vh;
        cursor: pointer;
        font-size: 1vw;
        &:before{
          display: none;
        }
        &.on{
          font-weight: bold;
        }
        &:hover{
          font-weight: bold;
        }

        .nav-item-title {
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }

        .arrow-down {
          display: inline-block;
          font-size: 12px;
          transition: transform 0.3s ease;
          transform-origin: center center;
        }
        &:hover .arrow-down {
          transform: rotate(180deg);
        }

        /* 👇 完全改成你截图里的样式 */
        .sub-nav {
          display: none;
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          min-width: 180px;
          background: #fff;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          z-index: 100;
          border-radius: 6px;
          padding: 0;
          /* 顶部尖角 */
          //&::before {
          //  content: '';
          //  position: absolute;
          //  top: -8px;
          //  left: 50%;
          //  transform: translateX(-50%);
          //  width: 0;
          //  height: 0;
          //  border-left: 8px solid transparent;
          //  border-right: 8px solid transparent;
          //  border-bottom: 8px solid #fff;
          //}

          .sub-item {
            border-radius: 6px;
            height: 40px;
            line-height: 40px;
            padding: 0 12px;
            font-size: 16px;
            color: #333;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            white-space: nowrap;
            &:first-child {
              padding-top: 16px;
            }
            &:last-child {
              padding-bottom: 16px;
            }
            &:hover {
              background: #f5f7fa;
              color: #024BFF;
            }
            .arrow {
              font-size: 18px;
              color: #666;
              margin-left: 8px;
            }
            .sub-sub-nav {
              display: none;
              position: absolute;
              left: 100%;
              top: 0;
              min-width: 160px;
              background: #fff;
              box-shadow: 0 2px 8px rgba(0,0,0,0.08);
              border-radius: 4px;
              .sub-sub-item {
                padding: 10px 20px;
                font-size: 16px;
                color: #333;
                cursor: pointer;
                &:hover {
                  background: #f5f7fa;
                  color: #024BFF;
                }
              }
            }
            &:hover .sub-sub-nav {
              display: block;
            }
          }
        }
        &:hover .sub-nav {
          display: block;
        }
      }
    }
  }
}
</style>